import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

const getVal = require('lodash/get');

/**
 * returns DLS TextArea component
 * @param {*} props
 */
const P = (props) => {
  const {
    cssProperties,
    fieldLabel,
    fieldId,
    fieldValidation,
    filledFormData,
    selectKey,
    nestedKey,
    selectKeys,
    separator,
    preFilledWith,
    isPreFilled,
    fetchUrl,
  } = props;

  const getPreFilledVal = () => {
    if (isPreFilled && preFilledWith === 'filledFormData' && !fetchUrl && filledFormData) {
      // Multi-key mode: selectKeys is an array of { selectKey, nestedKey } objects
      if (selectKeys && selectKeys.length > 0) {
        return selectKeys
          .map(({ selectKey: sk, nestedKey: nk }) => {
            const val = filledFormData[sk];
            return nk ? getVal(val, nk, '') : val || '';
          })
          .filter(Boolean)
          .join(separator ?? ' ');
      }
      // Single-key mode (backwards compatible)
      const val = filledFormData[selectKey];
      return nestedKey ? getVal(val, nestedKey, '') : val || '';
    }
    return '';
  };

  const [data, setData] = useState(getPreFilledVal);

  useEffect(() => {
    setData(getPreFilledVal());
  }, [filledFormData, selectKey, nestedKey, selectKeys, separator]);

  const renderElement = (
    <p className={cssProperties.style}>{parseHtml(data)}</p>
  );

  return (
    <>
      <label className={fieldLabel.cssProperties.style} htmlFor={fieldId}>
        {fieldLabel.label}
      </label>
      {fieldValidation && !fieldValidation.required && (
        <span className={fieldLabel.cssProperties.style}>{' '}(Optional)</span>
      )}
      {renderElement}
      {fieldValidation && fieldValidation.disabled && (
        <input type="hidden" id={fieldId} name={fieldId} value={data} />
      )}
    </>
  );
};

P.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  preFilledWith: PropTypes.string,
  fetchUrl: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  nestedKey: PropTypes.string,
  selectKeys: PropTypes.arrayOf(PropTypes.shape({
    selectKey: PropTypes.string,
    nestedKey: PropTypes.string,
  })),
  separator: PropTypes.string,
  isPreFilled: PropTypes.string,
};

export default P;
